export default __webpack_public_path__ + "static/media/phone-on-bike-narrow.b73b46b5.jpg";